module.exports = "<app-leadlist [data]=\"data\" (rowclick)=\"onRowClick($event)\"></app-leadlist>\n"